<app-onb-moldura passo="horarios" [estado]="estado" subtitulo="Fora desses horários a loja aparece fechada e o cliente não consegue pedir.">

  <div class="ph-agora" [class.ph-agora--aberta]="statusAgora.aberta">
    <i class="ph-bolinha"></i>
    <div>
      <b>Com esses horários, agora sua loja aparece {{ statusAgora.texto }}</b>
      <span>Não se preocupe com o teste: o seu pedido de teste passa mesmo com a loja fechada.</span>
    </div>
  </div>

  <div class="onb-grupo-rot">Atalhos</div>
  <div class="ph-chips">
    <button type="button" class="ph-chip" (click)="atalho('noite')">Todo dia 18h–23h</button>
    <button type="button" class="ph-chip" (click)="atalho('almoco')">Seg a sáb 11h–15h</button>
    <button type="button" class="ph-chip" (click)="atalho('copiar')">Copiar sexta para todos</button>
    <button type="button" class="ph-chip" (click)="atalho('segunda')">Fechado às segundas</button>
  </div>

  <div class="onb-grupo-rot">Semana</div>
  <div class="onb-grupo" id="onb-semana">
    <div class="onb-linha ph-dia" *ngFor="let n of ordem" [id]="'onb-dia-linha-' + n">
      <label class="onb-sw"><input type="checkbox" [id]="'onb-dia-' + n" [(ngModel)]="dia(n).aberto" [attr.aria-label]="nome(n) + ' aberto'"><span></span></label>
      <span class="ph-nome">{{ nome(n) }}</span>
      <div class="ph-horas" *ngIf="dia(n).aberto">
        <input class="onb-inp" type="time" [id]="'onb-abre-' + n" [(ngModel)]="dia(n).abre" [attr.aria-label]="nome(n) + ' abre'">
        <span>até</span>
        <input class="onb-inp" type="time" [id]="'onb-fecha-' + n" [(ngModel)]="dia(n).fecha" [attr.aria-label]="nome(n) + ' fecha'">
      </div>
      <span class="ph-fechado" *ngIf="!dia(n).aberto">Fechado</span>
      <span class="ph-madrugada" *ngIf="viraMadrugada(dia(n))">
        <i class="fas fa-moon"></i> Vira a madrugada: fecha às {{ dia(n).fecha }} de {{ diaSeguinte(n) }}.
      </span>
    </div>
  </div>
  <p class="onb-nota">Dois turnos no mesmo dia (almoço e noite) você acrescenta depois em Horários de funcionamento.</p>

  <div class="onb-erro" *ngIf="erro">{{ erro }}</div>

  <div class="onb-rodape">
    <span class="onb-dica">Fechar depois da meia-noite vira madrugada sozinho</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="salve()">
      {{ salvando ? 'Salvando…' : 'Salvar horários' }}
    </button>
  </div>
</app-onb-moldura>
